import { FC } from 'react';
import { Button, Col, Popconfirm, Row } from 'antd';
import { TbLogout, TbSitemap } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { WorkspaceIdentity } from '@/types';
import dayjs from '@/utilities/dayjs';

import AdvancedSettingsSectionHeader from '../../../components/AdvancedSettingsSectionHeader';

interface ForceLogoutSectionProps {
    forceLogout: () => void;
    forcingLogout: boolean;
    identity: WorkspaceIdentity | null;
    isEnterprise: boolean;
}

const ForceLogoutSection: FC<ForceLogoutSectionProps> = ({
    forceLogout,
    forcingLogout,
    identity,
    isEnterprise,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <Row align='top' gutter={[12, 12]} wrap={false}>
            <Col flex='auto'>
                <AdvancedSettingsSectionHeader
                    description='Revoke every active session in this workspace and require members to authenticate again.'
                    icon={<TbSitemap size='1rem' />}
                    plan='enterprise'
                    title='Force All Users to Logout'
                />
                {identity?.lastSessionRevocationAt && (
                    <small style={{ color: token.colorTextTertiary }}>
                        Last forced logout {dayjs(identity.lastSessionRevocationAt).format('MMM D, YYYY h:mm A')}
                    </small>
                )}
            </Col>
            <Col flex='none'>
                <Popconfirm
                    cancelText='Cancel'
                    disabled={!isEnterprise}
                    okButtonProps={{ danger: true, loading: forcingLogout }}
                    okText='Force Logout'
                    onConfirm={forceLogout}
                    placement='topRight'
                    title='Force all workspace users to log out?'
                    description='All active sessions for this workspace will be revoked immediately.'
                >
                    <Button danger disabled={!isEnterprise || forcingLogout} loading={forcingLogout} type='dashed'>
                        <TbLogout size='1rem' style={{ verticalAlign: '-0.175rem' }} />
                        Force Logout
                    </Button>
                </Popconfirm>
            </Col>
        </Row>
    );
};

export default ForceLogoutSection;
